namespace('compass.group');

compass.require('compass.demographic.GroupInfoWidget');
compass.require('compass.demographic.PasswordWidget');
compass.require('compass.demographic.AddressWidget');
compass.require('compass.group.GroupContractWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.demographic.PaymentWidget');

compass.require('compass.util.validate');
compass.requireLib('compass.util.format');

compass.group.GroupFormsWidget = compass.defineWidget(function GroupFormsWidget(options) {
	var me = this;

	var d = jQuery.dom;
	var $j = jQuery;

	var _settings = options;

	var _str2date = function (src) {
		src = src.split("-");
		return new Date(parseInt(src[0], 10), parseInt(src[1], 10),
				parseInt(src[2], 10), 0, 0, 0, 0);
	};

	var _lastElementFocused = null;

	var _validator = _settings.validator;

	var _form;
	var _invalid = false;


	var _groupInfoWidget, _passwordWidget, _addressWidget, _groupContractWidget, _paymentWidget;		

	var _drawAcceptTerms = function () {
	};

	var _drawTermsOfService = function(){
		if (_settings.meetingInfo.privacyPolicyLink.length === 0 ) return d.span({className: 'termsOfServiceText'}, '.');
		return [
				d.span({className: 'termsOfServiceText'}, ' and our '),
				d.a({className: 'termsOfServiceLink', 'href': _settings.meetingInfo.privacyPolicyLink, 'target': '_blank'}, 'terms of service.')
		];
	};
	
	this.render = function(widgetElem) {
		var recapArray = _settings.reservations;

		var _getGroupPaymentText = function() {
			var groupPaymentText;
			if (_settings.chargingInfo.hasCharging) {
				groupPaymentText = _settings.labels.groupPaymentWithCharging;
			} else {
				groupPaymentText = _settings.labels.groupPaymentWithoutCharging;
			}

			return groupPaymentText;
		};

		// setting up the hotel policies link to work for multiple hotels is to be done later
		var _drawPoliciesLink = function() {
			var policiesCopy = 'hotel policies';
			if(_settings.drawPoliciesLink) {
				return d.a({ className:'policiesLink'}, policiesCopy);
			} else {
				return d.span({ className:'policiesLink'}, policiesCopy);
			}
		};

		var _drawCreditCardTitle = function() {
			var _drawPaymentRequiredTitle = function() {
				if (_settings.paymentRequired) {
					var paymentRequiredTitleCopy = " Payment must be attached to this group or the reservations will be cancelled.";
					var paymentRequiredTitle = d.span({ className : 'paymentRequiredCreditCardTitle' }, (paymentRequiredTitleCopy));
					return paymentRequiredTitle;
				}
			};

			_drawCreditCardTitleCopy = function() {
				var _format = compass.util.dateFormatter('mm/dd/yyyy');
				var creditCardTitleCopy;

				var _renderChargeDate = function(){
					return _settings.chargingInfo.chargingToday ? " today" : " on " + _format(_settings.chargingInfo.chargingFirstDate);
				};

				if (_settings.chargingInfo.hasServiceFees) {
					creditCardTitleCopy = _settings.labels.needCardServiceFeesText;
				} else if (_settings.chargingInfo.hasCharging  ) { /* there is charging, today or in the future. */
					creditCardTitleCopy = _settings.labels.delayedChargingAndSetDate + _renderChargeDate() + ". Review the hotel policies for additional information.";
				} else {  /* the typical just guarnatee type. */
					var isPaymentComplex = _.findWhere(_settings.paymentOptions.pay_methods, {'is_credit_card': "N"});
					creditCardTitleCopy = (isPaymentComplex ? _settings.labels.needPayment : _settings.labels.needCreditCard);
				}

				return creditCardTitleCopy;
			};

			var creditCardTitle = [_drawCreditCardTitleCopy(), _settings.paymentRequired ? _drawPaymentRequiredTitle() : ""];
			return d.div({ className : 'creditCardTitle demographicTitle' }, creditCardTitle);
		};

		var groupInfoInstruction = "Start by entering the group's main contact info and you'll have the option to enter guest details and other preferences for each room in just a moment.";

		var policies_id = compass.generateId();
		_form = d.form({ className: 'forms' },
			d.div({ className : 'groupInfoHeader'},
				d.div({ className : 'groupInfoTitle'}, 'Group Reservation')
			),
			d.div({className : 'groupInfoInstruction'}, !_settings.paymentRequired ? groupInfoInstruction : ""),
			d.div({ className : 'groupInfoMain' }),
			d.div({ className : 'addressInfo' }),
			d.div({ className : 'passwordInfo' }),
			d.div({ className : 'paymentHeader' },
				d.div({ className : 'paymentTitle'}, _settings.labels.groupPayment)
			),
			_drawCreditCardTitle(),
			(_settings.paymentOptions.allowPaymentRequiredCancel === true ? d.a({className : 'cancelReservations','href':'javascript:;'}, 'Cancel reservations') : null ),
			d.div({ className : 'payment'}),
			d.div({ className : 'creditCard'}),			
			d.separator(),
			_drawAcceptTerms(),
			d.div({className : 'policiesAgreeDiv'},
				d.input({className : 'policiesCheckbox',
					name: 'policiesCheckbox',
					type: 'checkbox',
					'data-parsley-required': 'true',
					value:'true'}),
				d.div({className :'policiesTextDiv'}, 'By placing your booking with us, you agree to the'),
				_drawPoliciesLink(),
				_drawTermsOfService(),
				d.div({ className : 'clear'})
			),
			d.button({ className : 'saveButton button'}, 'Save')
		),

		widgetElem.append(_form);

		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();

			sendInfo();
		});

		_form.find('.placeholder').attr('aria-hidden', 'true');

		_groupInfoWidget = new compass.demographic.GroupInfoWidget(_form.find('.groupInfoMain'), {
			WUID : 'groupInfoWidget_groupFormsWidget',
			label: "Company/Group Name",
			prefill: _settings.groupInfo,
			editablePrefill: _settings.editablePrefill
		});

		if (!_settings.groupInfo) {
			_passwordWidget = new compass.demographic.PasswordWidget(_form.find('.passwordInfo'), {
				WUID : 'passwordWidget_groupFormsWidget',
			});
		}

			_paymentWidget = new compass.demographic.PaymentWidget(_form.find('.payment'), {
				WUID : 'creditCardWidget_groupFormsWidget',
				addressWidget : {countries : _settings.countriesAndStates.countries, states : _settings.countriesAndStates.states, countries_with_states : _settings.countriesAndStates.countries_with_states},
				creditCardTypes : _settings.paymentOptions.pay_methods,
				displayCVC: _settings.paymentOptions.store_cvc,
				currentPayment : (_settings.groupInfo && _settings.groupInfo.payments && _settings.groupInfo.payments.length > 0 )  ? _settings.groupInfo.payments[0] : false,
				storedPayments: (_settings.groupInfo && _settings.groupInfo.payments && _settings.groupInfo.payments.length > 0) ? _settings.groupInfo.payments  : false,
				minExpiration: _str2date(_settings.meetingInfo.ends),
				maskCCNumber : _.contains(_settings.extraRequiredFields, 'maskCreditCard'),
				payMethods: _settings.paymentOptions.pay_methods
			});
			if ( _settings.groupInfo && _settings.groupInfo.address ) {
				var addressObj = _settings.groupInfo.address;
				addressObj.postalCode = addressObj.postal_code;
				var aw = _paymentWidget.getAddressWidgetJSObject();
				if(aw) {
					aw.setAddress(addressObj);
				}
			}

		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		_form.parsley().on('form:error', function() {
 			_invalid = true;
 			return;
 		});

		_form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_form.parsley().on('field:validated', function(elem) {
			if (_invalid) {
				if (_form.find('.invalid').length <= 1) {
					_invalid = false;
					var button = _form.find('.saveButton');
					button.removeClass('disabled').attr('tabindex', '0');
				}
			}
		});
	};

	var sendInfo = function (event) {
		var d = jQuery.dom;
		var button = _form.find('.saveButton');
		if(button.hasClass('disabled')) {
			return;
		}
		button.addClass('disabled');

		var formData = {};
		// TODO: make this decision clear.
		formData.payment = _paymentWidget.grabValues();
		formData.policiesCheckbox = $j('.policiesCheckbox').prop('checked');
		if(formData.policiesCheckbox === false){
			_policiesAgreeDialog = d.alert('Please agree to the hotel policies before continuing');
		}

		_form.parsley().validate();

		if (_invalid) {
 			return;
 		}

		formData.contact = _groupInfoWidget.grabValues();
		if (_passwordWidget) {
			formData.password = _passwordWidget.grabValues();
		}

		compass.loading.start(button.empty(), { color : '#FFFFFF' });
		var finishLoading = function() {
			compass.loading.stop();
			button.empty().append('Save');
		};

		_settings.onFormSubmit(formData, finishLoading);
	};

}, {
	WUID : 'CRAP',
	widgetName : 'GroupFormsWidget',
	blockRoomId: [],
	countriesAndStates: {},
	extraRequiredFields: [],
	groupInfo: {},
	paymentOptions: {},
	reservations: [],
	validator: {},
	onFormSubmit: function() {},
	drawPoliciesLink: true,
	paymentRequired: false,
	labels: {
		groupPayment: "Group Payment",
		contractPayment: "Group Contract & Payment",
		needCardServiceFeesText: "We need a credit card to hold your rooms. You'll have the option to keep your rooms on this card or have each guest enter their own credit card. A Service &amp; Technology Fee will be charged to all cards on file today to cover the cost of managing your reservations. Review the hotel policies for additional information.",
		needCreditCard: "We need a credit card to hold your rooms. Don't worry, we won't charge it today. You'll have the option to keep your rooms guaranteed under this card or have each guest enter their own credit card. Review the hotel policies for additional information.",
		needPayment: "We need a form of payment to guarantee your rooms. You'll have the option to keep your rooms guaranteed under this form of payment or change it at a later date.",
		delayedChargingAndSetDate: "A deposit is required to reserve your rooms. Additional credit cards can be added to your rooms on the next page. All cards on file will be charged",
		noDelayedChargingOrChargingDatePassed: "A deposit is required to reserve your rooms. Additional credit cards can be added to your rooms on the next page. All cards on file will be charged today. Review the hotel policies for additional information."
	}
});
